import { usePlatformCatalogQuery } from '@platform/state/api';
import type { IGlobalModuleFacts } from './IGlobalModuleFacts';

/**
 * Стан модуля для глобальної сторінки «Записи й форми» (прототип v4 cust-module, cscope 'global'): увімкнено для всіх робочих просторів
 * (глобальна доступність) і кількість записів типу `rtKey` в усіх просторах (recN прототипу); без глобального рівня (`skip`) — не запитує.
 */
export function useGlobalModuleFacts(moduleKey: string, rtKey: string | undefined, skip: boolean): IGlobalModuleFacts {
  const { data } = usePlatformCatalogQuery(undefined, { skip });
  return {
    enabled: data?.modules.find((m) => m.key === moduleKey)?.enabled ?? true,
    recordCount: data?.recordTypes.find((r) => r.key === rtKey)?.recordCount,
  };
}
